module.exports = __webpack_public_path__ + "img/conveniencias-04.08ff1f6c.png";